<template>
  <div style="cursor: pointer;">
    <button :text="text" class="gr-btn-lite" :style="{ background: this.getBackgroundColor}">
      {{ text }}
    </button>
  </div>
</template>

<script>
import { colors } from '@/config'

export default {
  name: 'grBtnLite',
  props: {
    text: { type: String },
    backgroundColor: { type: String, default: 'tourquis' }
  },
  data () {
    return {
    }
  },

  methods: {
  },

  computed: {
    getBackgroundColor: function () {
      return this.backgroundColor === 'rose' ? colors.roseBright : colors.turquiseBright
    }
  },

  mounted () {
  }
}
</script>

<style lang="scss" scoped>
  .gr-btn-lite {
    cursor: pointer;
    padding: 10px 28px;
    border: 1.5px solid transparent;
    border-radius: 24px;
    font-family: $font-content;
    font-weight: 500;
    font-size: 0.85em;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin: 0.75em 0;
    transition: all .3s cubic-bezier(.25, .46, .45, .94);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
  .gr-btn-lite:hover {
    color: black;
    background: transparent !important;
    border-color: currentColor;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }
  .gr-btn-lite:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }
  @media(max-height: 670px) {
    .gr-btn-lite {
      padding: 5px 15px;
    }
  }

  @media(max-height: 570px) {
    .gr-btn-lite {
      font-size: 0.9em;
      font-weight: 600;
    }
  }

  @media(min-width: $window-lg) {
    .gr-btn-lite {
      padding: 15px 25px;
    }
  }
</style>
